<template>
    <div class="explanation-container">
        <section>
            <h3 class="text-h5 text-left mb-3">Jamie tapped the link!</h3>

            <div class="primary-note align-center my-4">
                <div class="primary-note-header">
                    <v-icon size="24" color="primary" class="pb-1 mr-2">
                        mdi-account-group
                    </v-icon>
                    <div>
                        <span>
                            Multiple caregivers received a link to this page. Real-time updates ensure that once someone claims the shift, others see it reflected immediately.
                        </span>

                        <div v-if="shift_status === 'available'" class="simulate-section">
                            <button class="simulate-button" @click="$emit('simulate-other-claim')">
                                Try it: Simulate another caregiver claiming this shift
                                <v-icon size="18" color="primary">mdi-chevron-right</v-icon>
                            </button>
                        </div>
        
                        <div v-else-if="shift_status === 'claimed_by_other'" class="simulate-result">
                            <div class="d-flex align-center gap-2">
                                <v-icon color="success" small>mdi-check-circle</v-icon>
                                <p class="mb-0">Another caregiver claimed the shift — notice how Jamie's view updated.</p>
                            </div>
                            <button class="simulate-button" @click="$emit('undo-simulate-other-claim')">
                                Undo
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <ul class="explanation-points">
                <li
                    class="explanation-point"
                    v-for="(point, idx) in explanation_points"
                    :key="idx"
                >
                    <v-icon
                        color="primary"
                        size="28"
                        class="point-icon"
                        aria-hidden="true"
                    >
                        mdi-chevron-right
                    </v-icon>
                    <p class="point-text" v-html="point"></p>
                </li>
            </ul>

            <div class="button-group">
                <v-btn color="primary" outlined @click="$emit('reset-web-experience')">
                    <v-icon 
                        left
                        size="20"
                    >
                        mdi-restart
                    </v-icon>
                    Restart Web Experience
                </v-btn>
                <v-btn color="primary" elevation="0" @click="$emit('reset')">
                    <v-icon 
                        left
                        size="20"
                    >
                        mdi-restart
                    </v-icon>
                    Restart Demo
                </v-btn>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'ExplainerLandingPage',

    props: {
        shift_data: {
            type: Object,
            required: true
        },
        shift_status: {
            type: String,
            required: true
        }
    },

    computed: {
        explanation_points() {
            return [
                `The landing page displays all relevant shift details so Jamie can make an informed decision`,
                `If another caregiver claims the shift first, Jamie sees an immediate update — no scheduling conflicts or confusion`,
                `The shift coordinator is notified instantly when someone claims the shift, eliminating back-and-forth communication`
            ];
        }
    }
}
</script>

<style lang="scss" scoped>
.explanation-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2rem;
    align-items: center;
    padding: 2rem;

    @media (max-width: 900px) {
        padding: .5rem 0;
    }
}

.primary-note {
    background: var(--color-bg-shaded-light);
    border-color: var(--color-bg-shaded);
    border-radius: calc(var(--border-radius-default) * 2);
    padding: 1rem;

    &-header {
        display: flex;
        align-items: flex-start;
    }
}

.simulate {
    &-section {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 0.5rem;
        margin-top: 0.75rem;
        padding-top: 0.75rem;
        border-top: 1px solid rgba(0, 0, 0, 0.08);
        font-size: 0.85rem;    
    }

    &-button {
        color: var(--v-primary-base);
        text-decoration: none;
        font-weight: 500;
        display: inline-flex;
        align-items: center;
        background: transparent;
        transition: opacity 0.2s;
    
        .v-icon {
            transition: transform 0.2s ease;
        }
    
        &:hover {
            opacity: 0.85;
    
            .v-icon {
                transform: translateX(2px);
            }
        }
    }
    
    &-result {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 0.25rem;
        margin-top: 0.75rem;
        padding-top: 0.75rem;
        border-top: 1px solid rgba(0, 0, 0, 0.08);
        font-size: 0.85rem;
        color: #555;
    }
}

.button-group {
    display: flex;
    gap: 1rem;
    margin-top: 2rem;
    flex-wrap: wrap;
    justify-content: center;
}
</style>
